
function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) as T : fallback;
  } catch {
    return fallback;
  }
}

function write<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch { void 0; }
}

export interface Comment {
  id?: string;
  article_id: string;
  text: string;
  author_id: string;
  author_name: string;
  created_at: string;
  is_affiliated: boolean;
}

export const commentsService = {
  // Crear un nuevo comentario
  async createComment(comment: Omit<Comment, 'id' | 'created_at'>): Promise<string> {
    try {
      const data = await apiClient.post('/comments', comment);
      return data.id as string;
    } catch {
      const list = read<Comment[]>('comments', []);
      const id = crypto.randomUUID();
      const now = new Date().toISOString();
      const newItem: Comment = { ...comment, id, created_at: now };
      write('comments', [newItem, ...list]);
      return id;
    }
  },

  // Obtener comentarios de un artículo específico
  async getCommentsByArticle(articleId: string): Promise<Comment[]> {
    try {
      const data = await apiClient.get(`/comments?articleId=${encodeURIComponent(articleId)}`);
      return (data || []) as Comment[];
    } catch {
      const list = read<Comment[]>('comments', []);
      return list.filter(c => c.article_id === articleId).sort((a,b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    }
  },

  // Eliminar un comentario (solo el autor puede eliminar)
  async deleteComment(commentId: string, userId: string): Promise<void> {
    try {
      await apiClient.delete(`/comments/${encodeURIComponent(commentId)}?authorId=${encodeURIComponent(userId)}`);
    } catch {
      const list = read<Comment[]>('comments', []);
      write('comments', list.filter(c => !(c.id === commentId && c.author_id === userId)));
    }
  }
};
import { apiClient } from './apiClient';
